import { render, staticRenderFns } from "./OrderUnderway.vue?vue&type=template&id=5a5bf703&"
import script from "./OrderUnderway.vue?vue&type=script&lang=ts&"
export * from "./OrderUnderway.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports